import { RichTranslator, useTranslator } from '@bluebeam/react-i18n';
import NewWindow from 'components/Icons/NewWindow';
import { Button, Modal, ModalContent, ModalFooter } from 'components/lib';
import { product } from 'copy/copy';
import React from 'react';

export type IntegrationContent = {
  title: string;
  subtitle?: string;
  text?: string;
  providerName: string;
  learnMore: {
    text?: string;
    textLink: string;
    link: string;
  };
};

interface Props {
  analyticsId: string;
  assets: {
    banner: string;
    icon: string;
  };
  getAuthUrl: () => Promise<string>;
  content: IntegrationContent;
  onCancel: () => void;
}

const AddDMSConnectionModal = (props: Props): React.ReactElement => {
  const { analyticsId, content, assets, onCancel } = props;
  const { translate } = useTranslator(['integrationsPage']);

  const contentName: `${string}:${string}` =
    `integrationsPage:${content?.providerName}.text` as `${string}:${string}`;
  const translatedContent = translate(contentName, {
    product: product.productName,
    [content?.providerName]: content?.title,
  });
  return (
    <Modal size="medium" onDismiss={onCancel} title={content.title}>
      <div id="add-dms-connection-modal">
        <div className="oh" style={{ height: '278px' }}>
          <img
            className="w100 align-self-center index-animated__static-phone"
            src={assets.banner}
            alt={`${content?.title} Connection`}
          />
        </div>
        <ModalContent>
          <div className="row">
            <div className="column justify-center">
              <img
                className="wrem-3p primary-blue"
                src={assets.icon}
                alt="filter filled icon"
              />
            </div>
            <div className="column justify-start pl3 light">
              <div className="color-black-2 font-size-7 semi-bold">
                {content.title}
              </div>
              <div className="color-black-1 font-size-4 pt1">
                {translate('integrationsPage:cloudStorage')}
              </div>
            </div>
          </div>
          <div id="description" className="column">
            <div className="h100  pt3 light">
              <div className="color-black-1 font-size-5 pb3">
                {translatedContent}
              </div>
              <div className="color-black-1 font-size-5 pb3">
                <RichTranslator
                  components={[
                    // eslint-disable-next-line jsx-a11y/anchor-has-content, jsx-a11y/control-has-associated-label
                    <a
                      href={content.learnMore.link}
                      target="_blank"
                      rel="noreferrer"
                      id="user-circle-popover-logout-btn"
                      className="m2 py1 cursor-pointer secondary-blue decoration-none"
                    />,
                  ]}
                  translationKey="integrationsPage:learnMoreAt"
                  variables={{
                    link: content.learnMore.textLink,
                  }}
                />
                <NewWindow fill="#00579C" width="20" height="19" />
              </div>
            </div>
          </div>
        </ModalContent>
        <ModalFooter>
          <Button
            id="integration-modal-cancel-btn"
            onClick={onCancel}
            size="large"
            variant="tertiary"
          >
            {translate('buttons:cancel')}
          </Button>
          <Button
            id="integration-modal-confirm-btn"
            data-analytics={`${analyticsId}-start-connection-button`}
            variant="primary"
            onClick={async () => {
              const authUrl = await props.getAuthUrl();
              window.location.href = authUrl;
              localStorage.setItem('started-connection', content.providerName);
            }}
          >
            {translate('integrationsPage:modal.submitButtonText')}
          </Button>
        </ModalFooter>
      </div>
    </Modal>
  );
};

export default AddDMSConnectionModal;
